export interface InputNumberTheme {
  iconBackgroundColor: string
  iconPaddingSmall: string
  iconPaddingMedium: string
  iconPaddingLarge: string
  iconSmallSize: string
  iconMediumSize: string
  iconLargeSize: string
  smallHeight: string
  mediumHeight: string
  largeHeight: string
}

export const DefaultInputNumberConfig: InputNumberTheme = {
  iconBackgroundColor: "#ebedf0",
  iconPaddingSmall: "3px 4px 4px 5px",
  iconPaddingMedium: "4px 4px 4px 5px",
  iconPaddingLarge: "12px",
  iconSmallSize: "16px",
  iconMediumSize: "24px",
  iconLargeSize: "24px",
  smallHeight: "24px",
  mediumHeight: "32px",
  largeHeight: "48px"
}
